var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 196.877,
    height: 71.015,
    viewBox: "0 0 196.877 71.015",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "IMG_-_LOGO_GALIPETTE_BLACK",
    "data-name": "IMG - LOGO GALIPETTE BLACK",
    transform: "translate(-194 -148.691)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Groupe_122",
    "data-name": "Groupe 122"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Groupe_13",
    "data-name": "Groupe 13",
    transform: "translate(231.605 209.488)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_13",
    "data-name": "Trac\\xE9 13",
    d: "M.392.615H-4.729c-.109,0-.109.012-.109-.109V-7.485c0-.12,0-.108.109-.108h1.961c.1,0,.109.012.109.108V-1.31L.38-1.37c.1,0,.108.025.108.121V.506c0,.1,0,.109-.1.109",
    transform: "translate(4.838 7.593)",
    fill: "#3c3c3b"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Groupe_14",
    "data-name": "Groupe 14",
    transform: "translate(237.403 211.425)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_14",
    "data-name": "Trac\\xE9 14",
    d: "M.225.123A1.031,1.031,0,0,0-.791,1.151H1.254A.984.984,0,0,0,.225.123M3.07,2.072c-.024.12-.059.145-.241.145H-.791A1.107,1.107,0,0,0,.445,3.281a1.544,1.544,0,0,0,1.161-.605c.037-.049.109-.023.17.062.254.35.593.835.836,1.21.072.109.036.194-.062.279a3.52,3.52,0,0,1-2.143.715A3.036,3.036,0,0,1-2.777,1.672,3.018,3.018,0,0,1,.407-1.512a2.65,2.65,0,0,1,2.736,2.76,3.266,3.266,0,0,1-.072.824",
    transform: "translate(2.777 1.512)",
    fill: "#3c3c3b"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Groupe_15",
    "data-name": "Groupe 15",
    transform: "translate(246.893 211.4)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_15",
    "data-name": "Trac\\xE9 15",
    d: "M.693.472H-1.148c-.071,0-.108,0-.108-.134V-3.124c0-.582-.23-.944-.763-.944a.865.865,0,0,0-.824.532V.29c0,.146-.012.182-.108.182h-1.84c-.072,0-.109,0-.109-.134V-3.124c0-.666-.339-.944-.763-.944a.87.87,0,0,0-.823.532V.338c0,.11-.012.134-.084.134H-8.448c-.085,0-.1,0-.1-.17V-5.5c0-.145,0-.145.085-.145h1.8c.1,0,.109,0,.109.145v.837A1.824,1.824,0,0,1-4.756-5.824,1.635,1.635,0,0,1-2.94-4.661,1.786,1.786,0,0,1-1.111-5.824,1.7,1.7,0,0,1,.8-3.887V.29C.8.436.79.472.693.472",
    transform: "translate(8.545 5.824)",
    fill: "#3c3c3b"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Groupe_16",
    "data-name": "Groupe 16",
    transform: "translate(257.364 211.4)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_16",
    "data-name": "Trac\\xE9 16",
    d: "M.243.146A1.243,1.243,0,0,0-.991,1.453,1.281,1.281,0,0,0,.255,2.785a1.236,1.236,0,0,0,1.2-1.332A1.217,1.217,0,0,0,.243.146M.231,4.7A3.105,3.105,0,0,1-3,1.453,3.128,3.128,0,0,1,.231-1.8,3.108,3.108,0,0,1,3.464,1.453,3.1,3.1,0,0,1,.231,4.7",
    transform: "translate(3.001 1.803)",
    fill: "#3c3c3b"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Groupe_17",
    "data-name": "Groupe 17",
    transform: "translate(264.966 209.318)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_17",
    "data-name": "Trac\\xE9 17",
    d: "M.245.306A1.18,1.18,0,0,0-.966,1.577,1.2,1.2,0,0,0,.245,2.849,1.216,1.216,0,0,0,1.468,1.577,1.2,1.2,0,0,0,.245.306M.7,4.688a2.081,2.081,0,0,1-1.755-.8l-.134.582c-.024.108-.132.146-.266.146H-2.927c-.1,0-.1-.013-.1-.158V-3.6c0-.17.012-.17.1-.17h1.8c.085,0,.1.024.1.158V-.735A1.769,1.769,0,0,1,.62-1.583,2.824,2.824,0,0,1,3.477,1.542C3.477,3.393,2.412,4.688.7,4.688",
    transform: "translate(3.024 3.774)",
    fill: "#3c3c3b"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Groupe_18",
    "data-name": "Groupe 18",
    transform: "translate(272.713 209.318)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_18",
    "data-name": "Trac\\xE9 18",
    d: "M.146.628H-1.707c-.084,0-.1,0-.1-.169v-5.8c0-.146,0-.146.084-.146H.134c.1,0,.121,0,.121.146V.5C.255.6.23.628.146.628m0-6.8H-1.707c-.084,0-.1-.084-.1-.157V-7.591c0-.074,0-.159.084-.159H.134c.1,0,.121.013.121.159v1.282c0,.109-.025.133-.109.133",
    transform: "translate(1.803 7.75)",
    fill: "#3c3c3b"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Groupe_19",
    "data-name": "Groupe 19",
    transform: "translate(276.259 209.318)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_19",
    "data-name": "Trac\\xE9 19",
    d: "M.147.628H-1.718c-.084,0-.1,0-.1-.17V-7.592c0-.146,0-.158.1-.158H.135c.085,0,.108.012.108.158V.494c0,.11-.023.134-.1.134",
    transform: "translate(1.814 7.75)",
    fill: "#3c3c3b"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Groupe_20",
    "data-name": "Groupe 20",
    transform: "translate(279.806 209.318)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_20",
    "data-name": "Trac\\xE9 20",
    d: "M.146.628H-1.707c-.084,0-.1,0-.1-.169v-5.8c0-.146,0-.146.084-.146H.134c.1,0,.121,0,.121.146V.5C.255.6.23.628.146.628m0-6.8H-1.707c-.084,0-.1-.084-.1-.157V-7.591c0-.074,0-.159.084-.159H.134c.1,0,.121.013.121.159v1.282c0,.109-.025.133-.109.133",
    transform: "translate(1.803 7.75)",
    fill: "#3c3c3b"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Groupe_21",
    "data-name": "Groupe 21",
    transform: "translate(282.989 211.425)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_21",
    "data-name": "Trac\\xE9 21",
    d: "M.225.123A1.031,1.031,0,0,0-.791,1.151H1.254A.985.985,0,0,0,.225.123M3.07,2.072c-.024.12-.059.145-.241.145H-.791A1.107,1.107,0,0,0,.445,3.281a1.544,1.544,0,0,0,1.161-.605c.037-.049.109-.023.17.062.254.35.593.835.836,1.21.072.109.036.194-.062.279a3.52,3.52,0,0,1-2.143.715A3.036,3.036,0,0,1-2.777,1.672,3.018,3.018,0,0,1,.407-1.512a2.65,2.65,0,0,1,2.736,2.76,3.266,3.266,0,0,1-.072.824",
    transform: "translate(2.777 1.512)",
    fill: "#3c3c3b"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Groupe_22",
    "data-name": "Groupe 22",
    transform: "translate(289.853 211.4)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_22",
    "data-name": "Trac\\xE9 22",
    d: "M.28.206a.445.445,0,0,1-.3.074c0-.546-.229-.837-.666-.837A.837.837,0,0,0-1.4-.1V3.62c0,.109-.025.134-.1.134H-3.364c-.084,0-.1,0-.1-.169v-5.8c0-.146,0-.146.1-.146h1.8c.084,0,.1,0,.1.146v.592a1.613,1.613,0,0,1,1.453-.92,1.41,1.41,0,0,1,1.55,1.465C1.286-.823.426.073.28.206",
    transform: "translate(3.46 2.542)",
    fill: "#3c3c3b"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Groupe_23",
    "data-name": "Groupe 23",
    transform: "translate(297.939 209.318)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_23",
    "data-name": "Trac\\xE9 23",
    d: "M.242.306A1.2,1.2,0,0,0-.98,1.565,1.227,1.227,0,0,0,.278,2.849,1.182,1.182,0,0,0,1.465,1.577,1.2,1.2,0,0,0,.242.306M3.293,4.617H1.61c-.108,0-.133-.05-.133-.195V4.071a1.887,1.887,0,0,1-1.55.617c-1.779,0-2.917-1.137-2.917-3.147A2.835,2.835,0,0,1-.133-1.582a2.115,2.115,0,0,1,1.55.616V-3.616c0-.134.012-.158.1-.158H3.329c.085,0,.1,0,.1.17V4.423c0,.145-.036.195-.133.195",
    transform: "translate(2.99 3.774)",
    fill: "#3c3c3b"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Groupe_24",
    "data-name": "Groupe 24",
    transform: "translate(305.481 211.425)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_24",
    "data-name": "Trac\\xE9 24",
    d: "M.225.123A1.033,1.033,0,0,0-.792,1.151H1.255A.986.986,0,0,0,.225.123M3.07,2.072c-.024.12-.059.145-.241.145H-.792A1.108,1.108,0,0,0,.443,3.281a1.545,1.545,0,0,0,1.162-.605c.037-.049.109-.023.17.062.254.35.592.835.836,1.21.072.109.036.194-.062.279a3.522,3.522,0,0,1-2.143.715A3.035,3.035,0,0,1-2.776,1.672,3.017,3.017,0,0,1,.407-1.512a2.65,2.65,0,0,1,2.736,2.76,3.266,3.266,0,0,1-.072.824",
    transform: "translate(2.776 1.512)",
    fill: "#3c3c3b"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Groupe_25",
    "data-name": "Groupe 25",
    transform: "translate(311.965 211.401)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_25",
    "data-name": "Trac\\xE9 25",
    d: "M.2.488c-1.537,0-2.266-.558-2.653-1.417-.023-.084-.023-.157.037-.182L-1.1-1.62a.092.092,0,0,1,.109.05,1.059,1.059,0,0,0,.982.654c.544,0,.787-.218.787-.484,0-.328-.255-.5-1.187-.726-1.15-.291-1.949-.7-1.949-1.913,0-1.271,1.04-1.985,2.724-1.985,1.344,0,2.143.509,2.385,1.307.012.074.012.146-.061.17L1.35-4.077c-.074.037-.086.037-.134-.036A1.071,1.071,0,0,0,.3-4.656c-.471,0-.678.156-.678.423,0,.242.278.363,1.32.569,1.211.254,2.045.763,2.045,1.9C2.984-.407,1.967.488.2.488",
    transform: "translate(2.467 6.025)",
    fill: "#3c3c3b"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Groupe_26",
    "data-name": "Groupe 26",
    transform: "translate(320.683 209.899)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_26",
    "data-name": "Trac\\xE9 26",
    d: "M.3.571A2.855,2.855,0,0,1-.935.909c-2.045,0-2.131-1.379-2.131-2.6V-3.812h-.5c-.085,0-.134,0-.134-.134V-5.217c0-.061.012-.145.1-.145h.533l.037-1.512c0-.122.012-.171.1-.171h1.719a.217.217,0,0,1,.231.206l-.025,1.477H.022c.084,0,.12.037.12.1v1.3c0,.12-.036.169-.132.169-.243,0-.739-.012-1.018-.012v2.24c0,.532.375.8,1,.666C.142-.944.2-.894.227-.762S.384.22.409.389A.163.163,0,0,1,.3.571",
    transform: "translate(3.696 7.045)",
    fill: "#3c3c3b"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Groupe_27",
    "data-name": "Groupe 27",
    transform: "translate(325.343 211.4)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_27",
    "data-name": "Trac\\xE9 27",
    d: "M.243.146A1.242,1.242,0,0,0-.991,1.453,1.28,1.28,0,0,0,.255,2.785a1.236,1.236,0,0,0,1.2-1.332A1.216,1.216,0,0,0,.243.146M.231,4.7A3.106,3.106,0,0,1-3,1.453,3.129,3.129,0,0,1,.231-1.8,3.108,3.108,0,0,1,3.464,1.453,3.1,3.1,0,0,1,.231,4.7",
    transform: "translate(3.002 1.803)",
    fill: "#3c3c3b"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Groupe_28",
    "data-name": "Groupe 28",
    transform: "translate(332.884 211.582)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_28",
    "data-name": "Trac\\xE9 28",
    d: "M.426.458H-1.33c-.1,0-.158-.012-.158-.182V-.329c-.253.7-.956.969-1.888.969-1.259,0-1.889-.7-1.878-2l.037-4.093c0-.17.024-.206.122-.206h1.827c.085,0,.11.037.11.17l-.038,3.62a.729.729,0,0,0,.763.8.875.875,0,0,0,.884-.582V-5.522c0-.109.012-.134.084-.134H.414c.085,0,.1,0,.1.17v5.8c0,.146,0,.146-.085.146",
    transform: "translate(5.253 5.656)",
    fill: "#3c3c3b"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Groupe_29",
    "data-name": "Groupe 29",
    transform: "translate(339.688 209.899)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_29",
    "data-name": "Trac\\xE9 29",
    d: "M.3.571A2.86,2.86,0,0,1-.936.909c-2.046,0-2.131-1.379-2.131-2.6V-3.812h-.5c-.085,0-.134,0-.134-.134V-5.217c0-.061.011-.145.1-.145h.533l.037-1.512c0-.122.012-.171.1-.171h1.72a.217.217,0,0,1,.23.206l-.025,1.477H.021c.085,0,.121.037.121.1v1.3c0,.12-.036.169-.133.169-.242,0-.738-.012-1.017-.012v2.24c0,.532.376.8,1,.666.146-.038.206.012.23.144S.384.22.408.389A.163.163,0,0,1,.3.571",
    transform: "translate(3.696 7.045)",
    fill: "#3c3c3b"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Groupe_30",
    "data-name": "Groupe 30",
    transform: "translate(344.578 213.119)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_30",
    "data-name": "Trac\\xE9 30",
    d: "M.29.139H-3.4c-.146,0-.169-.012-.169-.146V-1.568c0-.074.048-.146.169-.146H.29c.146,0,.17.012.17.146V-.007C.459.1.411.139.29.139",
    transform: "translate(3.572 1.714)",
    fill: "#3c3c3b"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Groupe_31",
    "data-name": "Groupe 31",
    transform: "translate(349.916 211.474)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_31",
    "data-name": "Trac\\xE9 31",
    d: "M.246.143A1.2,1.2,0,0,0-.976,1.427,1.232,1.232,0,0,0,.282,2.71,1.2,1.2,0,0,0,1.457,1.427,1.217,1.217,0,0,0,.246.143M.488,4.563A1.839,1.839,0,0,1-.976,3.847V6.305c0,.133-.012.158-.1.158H-2.951c-.072,0-.084,0-.084-.17V-1.515c0-.146,0-.146.084-.146h1.769c.083,0,.1,0,.1.146v.579C-.9-1.479-.069-1.769.584-1.769A2.808,2.808,0,0,1,3.468,1.379c0,2.19-1.272,3.256-2.979,3.184",
    transform: "translate(3.035 1.769)",
    fill: "#3c3c3b"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Groupe_32",
    "data-name": "Groupe 32",
    transform: "translate(357.263 211.425)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_32",
    "data-name": "Trac\\xE9 32",
    d: "M.225.123A1.031,1.031,0,0,0-.792,1.151H1.253A.985.985,0,0,0,.225.123M3.069,2.072c-.024.12-.061.145-.241.145H-.792A1.107,1.107,0,0,0,.442,3.281,1.545,1.545,0,0,0,1.6,2.676c.037-.049.109-.023.17.062.254.35.593.835.835,1.21.074.109.037.194-.059.279a3.525,3.525,0,0,1-2.143.715A3.035,3.035,0,0,1-2.778,1.672,3.018,3.018,0,0,1,.407-1.512a2.65,2.65,0,0,1,2.735,2.76,3.215,3.215,0,0,1-.072.824",
    transform: "translate(2.778 1.512)",
    fill: "#3c3c3b"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Groupe_33",
    "data-name": "Groupe 33",
    transform: "translate(363.654 209.899)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_33",
    "data-name": "Trac\\xE9 33",
    d: "M.3.571A2.856,2.856,0,0,1-.936.909c-2.045,0-2.13-1.379-2.13-2.6V-3.812h-.5c-.085,0-.134,0-.134-.134V-5.217c0-.061.012-.145.1-.145h.533l.037-1.512c0-.122.012-.171.1-.171h1.719a.217.217,0,0,1,.231.206l-.025,1.477H.022c.084,0,.12.037.12.1v1.3c0,.12-.036.169-.132.169-.243,0-.739-.012-1.018-.012v2.24c0,.532.375.8,1,.666C.142-.944.2-.894.227-.762S.384.22.409.389A.163.163,0,0,1,.3.571",
    transform: "translate(3.696 7.045)",
    fill: "#3c3c3b"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Groupe_34",
    "data-name": "Groupe 34",
    transform: "translate(368.679 209.318)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_34",
    "data-name": "Trac\\xE9 34",
    d: "M.146.628H-1.708c-.083,0-.1,0-.1-.169v-5.8c0-.146,0-.146.083-.146H.134c.1,0,.12,0,.12.146V.5C.254.6.23.628.146.628m0-6.8H-1.708c-.083,0-.1-.084-.1-.157V-7.591c0-.074,0-.159.083-.159H.134c.1,0,.12.013.12.159v1.282c0,.109-.024.133-.108.133",
    transform: "translate(1.803 7.75)",
    fill: "#3c3c3b"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Groupe_35",
    "data-name": "Groupe 35",
    transform: "translate(371.753 209.899)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_35",
    "data-name": "Trac\\xE9 35",
    d: "M.3.571A2.859,2.859,0,0,1-.935.909c-2.045,0-2.131-1.379-2.131-2.6V-3.812h-.5c-.085,0-.134,0-.134-.134V-5.217c0-.061.011-.145.1-.145h.534l.036-1.512c0-.122.012-.171.1-.171h1.72a.217.217,0,0,1,.23.206l-.025,1.477H.021c.085,0,.121.037.121.1v1.3c0,.12-.036.169-.133.169-.242,0-.738-.012-1.017-.012v2.24c0,.532.376.8,1,.666.146-.038.206.012.23.144S.384.22.408.389A.163.163,0,0,1,.3.571",
    transform: "translate(3.696 7.045)",
    fill: "#3c3c3b"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Groupe_36",
    "data-name": "Groupe 36",
    transform: "translate(376.398 211.401)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_36",
    "data-name": "Trac\\xE9 36",
    d: "M.2.488c-1.537,0-2.264-.558-2.651-1.417-.024-.084-.024-.157.036-.182L-1.1-1.62a.091.091,0,0,1,.108.05,1.059,1.059,0,0,0,.982.654c.544,0,.787-.218.787-.484,0-.328-.255-.5-1.187-.726-1.15-.291-1.949-.7-1.949-1.913,0-1.271,1.041-1.985,2.724-1.985,1.344,0,2.143.509,2.385,1.307.013.074.013.146-.061.17l-1.345.471c-.071.037-.083.037-.132-.036A1.072,1.072,0,0,0,.3-4.656c-.471,0-.678.156-.678.423,0,.242.278.363,1.32.569,1.211.254,2.046.763,2.046,1.9C2.985-.407,1.968.488.2.488",
    transform: "translate(2.466 6.025)",
    fill: "#3c3c3b"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Groupe_121",
    "data-name": "Groupe 121"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Groupe_1",
    "data-name": "Groupe 1",
    transform: "translate(194 154.073)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_1",
    "data-name": "Trac\\xE9 1",
    d: "M2.5,1.422C2.249.212,2.046-.745,1.956-1.125c-.415-1.764-.6-2.326-1.433-2.231L-4.929-2.121-11.085-.667a8.254,8.254,0,0,0-2.7.938c-.365.591.147,4.045.395,5.095.237,1,.27,1.146,3.182.459l3.653-.961c.086.584.749,3.6.869,4.324a11.25,11.25,0,0,1-4.839,2.548C-16.014,13.031-19.7,9.373-20.814,4.65-22.344-1.841-18.265-8.044-10.391-9.9c1.241-.292,2.553-.5,3.041-.568.394-.04,2.524-.19,3-.3.718-.169.981-.332,1.052-1.307a26.575,26.575,0,0,0-.03-4.828.679.679,0,0,0-.586-.568,31.146,31.146,0,0,0-8.851.928C-26.079-13.406-32.67-2.682-30.408,6.912A15.894,15.894,0,0,0-11.469,19.061c2.435-.574,3.585-1.248,6.931-3.3a22.5,22.5,0,0,1,7.725-3.13,1.6,1.6,0,0,0,.919-.443,6.285,6.285,0,0,1-1.736-1.543l.621-.475-.628.465A7.5,7.5,0,0,1,.95,6.479c0-.085-.005-.175-.005-.27a.223.223,0,0,1,0-.028A8.388,8.388,0,0,1,2.5,1.422M3.617,9.708a0,0,0,0,1,0,0h0c-.062-.08-.12-.163-.174-.246.054.083.111.165.172.245m.342.4a4.448,4.448,0,0,1-.341-.4h0a4.416,4.416,0,0,0,.342.4m-1.3-2.533a6.58,6.58,0,0,1-.149-1.166c0-.014,0-.027,0-.041,0,.015,0,.031,0,.049a6.6,6.6,0,0,0,.149,1.159",
    transform: "translate(30.846 17.541)",
    fill: "#3c3c3b"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Groupe_2",
    "data-name": "Groupe 2",
    transform: "translate(270.417 164.171)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_2",
    "data-name": "Trac\\xE9 2",
    d: "M2.1.543A8.967,8.967,0,0,0-4.732-6.013a17.682,17.682,0,0,0-4.605.161,21.874,21.874,0,0,1-5.908-.059c-1.062-.179-2.3-.539-3.069-.67-1.98-.339-2.014-.144-2.84,3.843C-22.483,3.9-25.75,21.637-25.885,23.3c-.1,1.178.158,1.421,2.572,1.83l2.949.5c2.805.477,2.844.236,3.239-1.486.276-1.049,1.2-6.463,1.758-10.048a10.713,10.713,0,0,0,4.459,1.853A11.361,11.361,0,0,0-.419,11.8,12.639,12.639,0,0,1-.708,9.076c0-.011,0-.038,0-.08V8.976A13.58,13.58,0,0,1-.627,7.458,12.821,12.821,0,0,1,2.1.543m-7.707,3.9a4.924,4.924,0,0,1-4.664,5.172A4.926,4.926,0,0,1-15.45,4.957,4.93,4.93,0,0,1-10.787-.222,4.928,4.928,0,0,1-5.607,4.443",
    transform: "translate(25.902 6.695)",
    fill: "#3c3c3b"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Groupe_3",
    "data-name": "Groupe 3",
    transform: "translate(297.173 168.09)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_3",
    "data-name": "Trac\\xE9 3",
    d: "M1.853.8C1.458,4.795-12.675,5.72-13.368,2.341c.237,1.157-.248,4.757,4.387,5.237,4,.414,8.9-2.182,9.44-2.124.342.035.359.332.386,1.025S.875,8.552.825,9.04c-.061.586-.283,1.3-2.911,2.409a18.549,18.549,0,0,1-9.668,1.461c-7.512-.778-11.723-5.8-11.034-12.43.922-8.872,8.971-10.9,14.777-10.294C-2.353-9.225,2.637-7.143,1.853.8M-9.834-6.581a3.382,3.382,0,0,0-3.2,3.552A3.38,3.38,0,0,0-9.48.166a3.38,3.38,0,0,0,3.2-3.548,3.381,3.381,0,0,0-3.553-3.2",
    transform: "translate(22.862 9.913)",
    fill: "#3c3c3b"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Groupe_4",
    "data-name": "Groupe 4",
    transform: "translate(339.892 173.488)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_4",
    "data-name": "Trac\\xE9 4",
    d: "M2.177,1.175C-6.966,4.5-18.692,6.434-26.858,5.565-18.53,9.2-5.235,8.886,4.41,5.378s17-11.533,19.717-19.873C18.429-8.587,11.318-2.152,2.177,1.175",
    transform: "translate(26.858 14.495)",
    fill: "#3c3c3b"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Groupe_5",
    "data-name": "Groupe 5",
    transform: "translate(261.872 163.364)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_5",
    "data-name": "Trac\\xE9 5",
    d: "M.767.658C.58,2.07-.243,8.39-.367,9.656c-.177,1.8-.281,2.336-.942,2.565A17.526,17.526,0,0,1-5.044,12.1c-4.39-.431-4.512-.691-4.393-1.909.368-3.7,2.429-16.627,2.511-17.456.194-.966.29-.958,2.585-.731l5.22.515c.829.081.973.637.795,2.441Z",
    transform: "translate(9.463 8.122)",
    fill: "#3c3c3b"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Groupe_6",
    "data-name": "Groupe 6",
    transform: "translate(323.75 162.15)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_6",
    "data-name": "Trac\\xE9 6",
    d: "M1.1.9C1.049,2.423.808,2.58-.072,2.651c-1.713.147-2.02.028-4.614.2-.038,2.108-.169,4.413-.1,6.815.064,2.253.126,4.411,3.36,4.317a13.249,13.249,0,0,0,3.8-.989c.246-.008.5.133.716,1.011A20.21,20.21,0,0,1,3.6,16.586c.043,1.469-5.316,2.75-8.307,2.836-7.5.215-8.787-5.389-8.9-9.309-.057-1.962.582-19.089.712-19.682.089-.4.235-.4,1.307-.626a57.837,57.837,0,0,1,6.152-.962c1.03-.028,1.183.213,1.212,1.192.017.589-.15,3.342-.184,3.881-.07.933-.093,1.916-.141,3.634,1.173-.083,3.826-.225,4.514-.243C.9-2.717,1.007-2.427,1.05-.958Z",
    transform: "translate(13.605 11.159)",
    fill: "#3c3c3b"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Groupe_7",
    "data-name": "Groupe 7",
    transform: "translate(227.351 161.274)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_7",
    "data-name": "Trac\\xE9 7",
    d: "M.657.387a40.075,40.075,0,0,0-5.27.788C-5.2,1.2-5.313.861-5.588.037a10.013,10.013,0,0,1-.53-2.285c-.026-.686.161-.941,1.421-1.378A28,28,0,0,1,1.736-4.759c3.625-.137,7.424.4,9.882,3.058,1.892,1.988,2.424,4.372,2.615,9.418.023.541.2,6.371.031,7.21-.205,1.085-.742,1.155-1.525,1.187-1.667.063-2.889.157-4.064.2-3.529.136-7.791,1.62-10.191,1.712-1.271.05-3.975-.043-5.474-2.044A5.917,5.917,0,0,1-8.1,12.694c-.125-3.282,2.471-8.535,13.162-8.7C4.671,1.461,3.84.265.657.387M2.97,7.239a3.38,3.38,0,1,0,3.553,3.2,3.381,3.381,0,0,0-3.553-3.2",
    transform: "translate(8.103 4.778)",
    fill: "#3c3c3b"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Groupe_8",
    "data-name": "Groupe 8",
    transform: "translate(338.935 159.771)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_8",
    "data-name": "Trac\\xE9 8",
    d: "M1.142.839c.178,1.513-.037,1.7-.9,1.909-1.67.406-1.8.129-4.338.7.284,2.089.508,4.386.941,6.747.406,2.219.8,4.34,3.978,3.756a13.381,13.381,0,0,0,3.605-1.559c.239-.044.509.056.859.889a20.374,20.374,0,0,1,.9,2.479c.265,1.445-4.837,3.526-7.779,4.069-7.378,1.355-9.5-3.989-10.214-7.847-.354-1.929-1.049-6.456-1.311-9.205-.25-2.637-1.024-9.748-.984-10.354.026-.405.169-.43,1.2-.817a57.194,57.194,0,0,1,5.934-1.888c1.014-.187,1.2.028,1.378.991.107.579.363,3.325.412,3.864.072.935.2,1.908.414,3.615,1.147-.262,3.553-.6,4.23-.724C.392-2.711.538-2.439.8-.991Z",
    transform: "translate(14.092 10.35)",
    fill: "#3c3c3b"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Groupe_9",
    "data-name": "Groupe 9",
    transform: "translate(356.321 161.251)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_9",
    "data-name": "Trac\\xE9 9",
    d: "M1.7.44C3.351,4.1-8.427,11.953-10.718,9.379c.786.882,2.165,4.238,6.417,2.339C-.627,10.08,2.32,5.384,2.813,5.167c.315-.142.479.107.85.694S4.726,7.637,4.924,8.086c.24.534.405,1.267-1.319,3.536a18.535,18.535,0,0,1-7.639,6.1c-6.895,3.081-13.054.837-15.774-5.251-3.638-8.139,2.319-13.914,7.645-16.3C-6.966-6.147-1.6-6.84,1.7.44M-12.12-.117a3.379,3.379,0,0,0-1,4.676,3.383,3.383,0,0,0,4.677.995A3.383,3.383,0,0,0-7.444.877,3.382,3.382,0,0,0-12.12-.117",
    transform: "translate(20.925 5.424)",
    fill: "#3c3c3b"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Groupe_10",
    "data-name": "Groupe 10",
    transform: "translate(265.5 150.092)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_10",
    "data-name": "Trac\\xE9 10",
    d: "M.665.315a4.435,4.435,0,0,1-4.2,4.661A4.436,4.436,0,0,1-8.194.779,4.435,4.435,0,0,1-4-3.881,4.432,4.432,0,0,1,.665.315",
    transform: "translate(8.2 3.887)",
    fill: "#3c3c3b"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Groupe_11",
    "data-name": "Groupe 11",
    transform: "translate(251.17 148.691)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_11",
    "data-name": "Trac\\xE9 11",
    d: "M.473.012,2.532.058c2.057.1,2.152.15,2.344.308.282.209.274.405.189,2.216-.042.882-.158,2.3-1.092,14.924-.126,1.664-1.026,14.576-1.2,15.156-.169.432-.463.419-1.348.427l-2.694-.078c-.637-.029-3.723-.173-4.064-.239-.437-.117-.522-.415-.5-.9.028-.586.067-1.418.6-8.608.2-3.133,1.183-16.834,1.362-19.623.176-2.742.2-3.183.6-3.5.308-.282.7-.314,1.976-.253Z",
    transform: "translate(5.835 0.146)",
    fill: "#3c3c3b"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Groupe_12",
    "data-name": "Groupe 12",
    transform: "translate(207.085 185.302)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_12",
    "data-name": "Trac\\xE9 12",
    d: "M1.9.451c10.166-2.8,20.519-4.136,29.467-2.883C22.451-6.081,11.051-6.618.326-3.662a41.4,41.4,0,0,0-23.739,17A66.441,66.441,0,0,1,1.9.451",
    transform: "translate(23.413 5.568)",
    fill: "#3c3c3b"
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.0a87656ed18b878fb6640c21c65516d3.svg";
export { ForwardRef as ReactComponent };